<template>
  <div class="d-followers-list">
    <div
      v-if="!followersMixinData.isEmpty"
      class="grid-3 border-bottom-dark padding-bottom-2em space-bottom-4em"
    >
      <div class="grid-item-2">
        <h2>
          {{ followersMixinData.titleText }}
        </h2>
      </div>
      <div class="grid-item">
        <DuiSearchInput
          v-model="followersMixinData.searchText"
          placeholder="Search..."
          @input="textSearchFollows"
        />
      </div>
    </div>

    <!-- Empty -->
    <div
      v-if="!followersMixinData.isLoading && !followersMixinData.results.usersList.length"
      class="no-followers panel background-grey"
    >
      <img
        alt="No followers"
        :src="emptyImageSrc"
      >

      <div v-if="followersMixinData.isEmpty">
        <h2>{{ emptyText }}</h2>
        <p
          v-if="isSelf"
          v-once
          class="large">
          But they will appear here as soon as they do
          <span class="emoji">😊</span>
        </p>
      </div>

      <h2 v-else>
        No results
      </h2>
    </div>
    <!-- END Empty -->

    <div
      v-else
      class="users-list grid-3"
    >
      <DUserListEntry
        v-for="user in followersMixinData.results.usersList"
        :key="user.slug"
        :allow-removal="(isSelf && type === 'follows')"
        class="grid-item"
        :user="user"
        @remove="removeUser"
      />
    </div>


    <div
      v-if="followersMixinData.isLoading"
      class="text-center space-top-8em"
    >
      <DuiLoadingIndicator
        class="loading-content"
        size="lg"
      />
    </div>

    <div
      id="load-more-follows"
      class="load-more-follows"
    />
  </div>
</template>

<script>
import DUserListEntry from '@d-components/d-user-list-entry/d-user-list-entry.vue';
import followersListMixin from '@d-mixins/followers-list';
import { FOLLOWERS_SEARCH } from '@d-shared/config';

export default {
  components: {
    DUserListEntry,
  },
  mixins: [
    followersListMixin,
  ],
  data: () => ({
    emptyImageSrc: require('@d-assets/books-glasses-round.svg'),
    emptyText: null,
  }),
  mounted() {
    this.setupFollowersListMixin(this.type, FOLLOWERS_SEARCH);
    this.setupInitialData();
  },
  methods: {
    setEmptyText() {
      const userName = this.userName || 'User';

      let emptyText = [
        this.isSelf ? `You are` : `${ userName } is`,
        'not',
        (this.type === 'followers') ? 'followed by' : 'following',
        'anyone yet!',
      ].join(' ');

      this.$set(this, 'emptyText', emptyText);
    },

    async setupInitialData() {
      await this.performSearch();
      this.setEmptyText();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@dui-styles/base";

.d-followers-list {
  min-height: 500px;
  position: relative;

  .load-more-follows {
    bottom: 0;
    position: absolute;
  }

  .no-followers {
    padding-bottom: $_5em;
    padding-top: $_8em;
    text-align: center;

    img {
      height: 200px;
      width: 200px;
    }

    h2 {
      margin-top: $_2em;
    }
  }
}
</style>
